import messageInformationSnackBar from '@/services/general/snackbar/snackBarInfo';

export default function messageSuccessSnackBar(message, messageAction, action) {
  messageInformationSnackBar(message, messageAction, action, 'is-success');
}
